import React, { useState } from 'react';

import DataTableContainer from '../../components/DataTableContainer';
import MyDataTable from '../../components/MyDataTable';
import { ServerFarmInterface, streamServersService, VideoStorageProvider } from '../../services/central-api/stream-servers';
import { translate } from '../../services/translate';
import { View } from 'react-native';
import Badge from '../../components/Badge';
import DropdownButton from '../../components/DropdownButton';
import ConfirmModal from '../../components/ConfirmModal';
import moment from 'moment';

interface ServerFarmDetailVideoStorageProvidersParams {
    serverFarm: ServerFarmInterface;
    setServerPoolId: (serverPoolId: string | null) => void;
    setTimelineProviderId: (timelineProviderId: number | null) => void;
    setVideoStorageProviderId: (videoStorageProvider: number | null) => void;
    setSelectedTab: (selectedTab: 'serverPools' | 'timelineProviders' | 'videoStorageProviders' | 'servers' | null) => void;
    refetch: () => void;
}

export default function ServerFarmDetailVideoStorageProviders(params: ServerFarmDetailVideoStorageProvidersParams) {
    const [isModalVisible, setModalVisible] = useState(false);
    const [selectedVideoStorageProvider, setSelectedVideoStorageProvider] = useState<VideoStorageProvider | null>(null);

    return (<>
        <DataTableContainer
            dataTable={<MyDataTable
                data={params.serverFarm.videoStorageProviders}
                pointerOnHover
                onRowClicked={(row) => {
                    params.setServerPoolId(null);
                    params.setTimelineProviderId(null);
                    params.setVideoStorageProviderId(row.id);
                    params.setSelectedTab(null);
                }}
                columns={[{
                    name: translate('id'),
                    cell: row => row.id,
                    minWidth: '75px',
                    grow: 0,
                }, {
                    name: translate('type'),
                    selector: row => row.blobStorageType,
                }, {
                    name: translate('name'),
                    selector: row => row.bucketName,
                }, {
                    name: translate('createdAt'),
                    selector: row => moment(row.createdAt).format('DD/MM/YYYY HH:mm'),
                }, {
                    name: translate('servers'),
                    selector: row => row.serverCount,
                    center: true,
                }, {
                    name: translate('defaultForServers'),
                    cell: row => {
                        if (row.id === params.serverFarm.defaultVideoStorageProviderId) {
                            return <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                                <Badge mode='SQUARE' key={row.id} color='green'>
                                    {translate('defaultForNewServers')}
                                </Badge>
                            </View>;
                        }

                        return <></>;
                    },
                    wrap: true,
                }, {
                    name: '',
                    button: true,
                    wrap: true,
                    cell: (row) => {
                        return (
                            <DropdownButton
                                size={320}
                                offsetX={-168}
                                actions={[{
                                    content: translate('setAsDefault'),
                                    omit: row.id === params.serverFarm.defaultVideoStorageProviderId,
                                    onPress: () => {
                                        setSelectedVideoStorageProvider(row);
                                        setModalVisible(true);
                                    },
                                }]}
                            />
                        );
                    }
                }]}
            />}
        />
        <ConfirmModal
            maxWidth={400}
            setModalVisible={setModalVisible}
            isModalVisible={isModalVisible}
            customMessage={translate('setVideoStorageProviderAsDefault', {
                videoStorageProvider: `${selectedVideoStorageProvider?.id} - ${selectedVideoStorageProvider?.blobStorageType} - ${moment(selectedVideoStorageProvider?.createdAt).format('DD/MM/YYYY')}`,
            })}
            customConfirm={translate('confirm')}
            onSubmit={async () => {
                try {
                    if (!selectedVideoStorageProvider) {
                        return;
                    }
                    await streamServersService.setVideoStorageProviderAsDefault(selectedVideoStorageProvider.id);
                    params.refetch();
                } catch (err) {
                    console.error(err);
                }
            }}
            onCancel={() => {
                setSelectedVideoStorageProvider(null);
            }}

        />
    </>);
}
